import { OfflineContentStatus } from '../enums/offline-content-status';

export class ModelSelect {
  model: string;
  selected: OfflineContentStatus;
  isDirty: boolean;
}
